/*******************************************************
Toggle Sub Navigation
Triggers the sub-navigation menus to show or hide.
********************************************************/

import closeDropdownMenu from './close-dropdown';

// Trigger the navigation menu to close (if it should)
export default function triggerCloseDropdownMenu(e) {
    const $wasOn = $(e.currentTarget);
    const $movedTo = $(e.relatedTarget);

    // Check if the mouse was moved from a dropdown menu to a nav item
    const movingFromDropdownToItem = ($wasOn.hasClass('s-sub-nav__group') || $wasOn.hasClass('section-sub-nav__group') || $wasOn.hasClass('section-sub-nav__inner'))
                                    && ($movedTo.hasClass('s-nav') || $movedTo.hasClass('s--nav__item') || $movedTo.hasClass('section-nav') || $movedTo.hasClass('section--nav__item'));

    // Check if the mouse was moved from a nav item to a dropdown menu
    const movingFromItemToDropDown = ($wasOn.hasClass('s-nav__item') || $wasOn.hasClass('section-nav__item'))
                                    && ($movedTo.hasClass('s-sub-nav__group') || $movedTo.hasClass('s-sub-nav__link') || $movedTo.hasClass('section-sub-nav__group') || $movedTo.hasClass('section-sub-nav__inner') || $movedTo.hasClass('section-sub-nav__link'));

    // If the mouse isn't on or moving to part of the selected
    // navigation (dropdown menu + selected nav item), then close the menu
    if (!movingFromDropdownToItem && !movingFromItemToDropDown) { closeDropdownMenu(); }
}
